import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPhotoComponent } from "./med-icon-photo.component";

@NgModule({
  declarations: [
    MedIconPhotoComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPhotoComponent,
  ],
})
export class MedIconPhotoModule { }
